import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { GlobalVariable } from './../shared/global';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class PlanService {
  private baseApiUrlTest=GlobalVariable.BASE_API_URL;
  private reqHeaders = new Headers({'Content-Type': 'application/json'});
  private get_plan_url = this.baseApiUrlTest + 'api/rest/v1/google/plan/';
  private get_document = this.baseApiUrlTest + 'api/enrollment/download/document/';

  constructor(private http: Http) { }

  getPlan(address_with_tdu: Object) {
    return this.http.post(this.get_plan_url, address_with_tdu)
               .toPromise()
               .then(response => response.json())
               .catch(this.handleError);
  }

  getDocument(document_name: string, language: string) {
    // window.open(this.get_document_url + language + '/' + document_name + '/', '_blank');
    // return null;
    return this.http.get(this.get_document+language+'/'+document_name+'/')
               .toPromise()
               .then(response => response.json())
               .catch(this.handleError);
  }

  getDocumentUrls(){
    return this.http.get('assets/properties/app.json')
              .toPromise()
              .then(res => res.json())
              .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/plan/plan.service.ts